// src/components/ErrorBoundary.tsx
import { Component, ReactNode } from "react";

export class ErrorBoundary extends Component<
  { children: ReactNode },
  { hasError: boolean }
> {
  state = { hasError: false };
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(err: any) {
    console.error("UI crash:", err);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="p-6 text-center">
          <h2 className="text-xl font-semibold">Ops, algo deu errado</h2>
          <p className="text-sm text-muted-foreground mt-2">
            Atualize a página ou tente outro navegador.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}
